var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUnlocked)?_c('div',{staticClass:"l-black-hole-upgrade-grid__row"},[_c('ExpoBlackHoleUpgradeButton',{attrs:{"config":_vm.powerConfig}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }